/*
  Softy Shapes header.

  Three small jobs:
  - toggle `.sh-header--top` so the bar is transparent at the top of
    an overlay page and solid once scrolled
  - optionally hide the bar while scrolling down, reveal on scroll up
  - close dropdowns and the mobile drawer on outside click or Escape
*/
(function () {
  'use strict';

  function init(scope) {
    var headers = (scope || document).querySelectorAll('[data-sh-header]');

    headers.forEach(function (header) {
      if (header.dataset.shHeaderBound) return;
      header.dataset.shHeaderBound = 'true';

      var overlay = header.hasAttribute('data-sh-overlay');
      var hideOnDown = header.hasAttribute('data-sh-hide-down');
      // The hero's big wordmark, if the page opens on one: the bar's
      // own wordmark only shows once that has scrolled up under the bar.
      var heroWordmark = header.hasAttribute('data-sh-hands-wordmark')
        ? document.querySelector('[data-sh-hero-wordmark]')
        : null;
      if (header.hasAttribute('data-sh-hands-wordmark') && !heroWordmark) {
        header.classList.add('sh-header--wordmark-in');
      }
      var lastY = window.scrollY;
      var ticking = false;

      function update() {
        ticking = false;
        var y = window.scrollY;

        // Only overlay pages have a transparent state to return to.
        if (overlay) {
          header.classList.toggle('sh-header--top', y <= 8);
        } else {
          header.classList.remove('sh-header--top');
        }

        if (heroWordmark) {
          // Once the whole title is under the bar, not as it starts to go.
          var barBottom = header.getBoundingClientRect().bottom;
          var titleBottom = heroWordmark.getBoundingClientRect().bottom;
          header.classList.toggle('sh-header--wordmark-in', titleBottom <= barBottom);
        }

        if (hideOnDown) {
          var goingDown = y > lastY && y > 200;
          var openMenu = header.querySelector('details[open]');
          header.style.transform =
            goingDown && !openMenu ? 'translateY(-100%)' : 'translateY(0)';
        }

        lastY = y;
      }

      var settle = null;
      window.addEventListener('scroll', function () {
        // The bar itself moves for a moment after a scroll (it follows
        // the offers bar sliding away), so look again once it has
        // settled, not only while the page is moving.
        clearTimeout(settle);
        settle = setTimeout(update, 380);
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });

      header.addEventListener('transitionend', function (event) {
        if (event.target === header) update();
      });

      update();

      // --- dropdowns and drawer ---

      var panels = header.querySelectorAll('details');

      function closeAll(except) {
        panels.forEach(function (d) {
          if (d !== except) d.removeAttribute('open');
        });
      }

      panels.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) closeAll(d);
        });
      });

      document.addEventListener('click', function (event) {
        if (!header.contains(event.target)) closeAll();
      });

      // The close button inside the full-screen menu.
      header.querySelectorAll('[data-sh-drawer-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          var drawer = button.closest('details');
          if (!drawer) return;
          drawer.removeAttribute('open');
          var summary = drawer.querySelector('summary');
          if (summary) summary.focus();
        });
      });

      header.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeAll();
        var open = header.querySelector('details[open] > summary');
        if (open) open.focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
